export default "/images/vendor/flag-icon-css/flags/4x3/ax.svg?6651bb2513bc040f7f2b02f9c503b288";